export const serviceCenterTag = 'serviceCenter:';
